const SmsActionTypes = {
  FETCH_SMS_CONFIGURATION: 'FETCH_SMS_CONFIGURATION',
  FETCH_SMS_CONFIGURATION_SUCCESS: 'FETCH_SMS_CONFIGURATION_SUCCESS',
  FETCH_SMS_CONFIGURATION_FAILURE: 'FETCH_SMS_CONFIGURATION_FAILURE',

  UPDATE_SMS_CONFIGURATION: 'UPDATE_SMS_CONFIGURATION',
  UPDATE_SMS_CONFIGURATION_SUCCESS: 'UPDATE_SMS_CONFIGURATION_SUCCESS',
  UPDATE_SMS_CONFIGURATION_FAILURE: 'UPDATE_SMS_CONFIGURATION_FAILURE',

  FETCH_SMS_LOGS: 'FETCH_SMS_LOGS',
  FETCH_SMS_LOGS_SUCCESS: 'FETCH_SMS_LOGS_SUCCESS',
  FETCH_SMS_LOGS_FAILURE: 'FETCH_SMS_LOGS_FAILURE',
};

export default SmsActionTypes;
